//angular-oidc-client authentication
import * as moment from 'moment';
import { title } from 'process';
import { environment } from 'src/environments/environment';

export const authClientId = 'angular-client';
export const authIdpAuthorityUrl = 'https://login.microsoftonline.com/common/v2.0/.well-known/openid-configuration';
//"https://schidentityserverdev.azurewebsites.net";
export const authCookieKey = 'bluePrint_auth_cookie_key';

//msal authentication
export const msalTenantUrl = 'https://login.microsoftonline.com/organizations';
export const previewImageUrl = 'https://schmappstracc.z13.web.core.windows.net/assets/images/Machine%20Library.svg';

export const initialHazards = 'Initial_Hazards';
export const offerDetails = 'offerDetails';
export const roadmapLibrary = 'Roadmap_Library';
export const standardsDocuments = 'Standards_Documents';
export const legislationsDocuments = 'Legislations_Documents';
export const riskAssessmentReport = 'RiskAssessment_Report';
export const quoteTemplateLibrary = 'Quote_TemplateLibrary';
export const machineLibrary = 'Machine_Library';
export const controlMeasures = 'Control_Measures';
export const machineDetailedPageDefaultTab = 'machineInfo';
export const machineStatusList = ['Operational', 'Out of Service', 'Under Maintenance', 'Emergency Shutdown', 'Calibration', 'Testing', 'Idle', 'Standby', 'Faulty', 'Pending Approval', 'Scheduled Shutdown', 'Decommissioned', 'Unknown'];
export const machineModeList = [{ machineMode: 'Normal' }, { machineMode: 'Setup' }, { machineMode: 'Maintenance' }, { machineMode: 'Other' }];
export const lifeCyclePhaseList = [{ lifeCyclePhase: 'Others' }, { lifeCyclePhase: 'Take out of Service' }, { lifeCyclePhase: 'Disassembly' }, { lifeCyclePhase: 'Transport' }, { lifeCyclePhase: 'Assembly' }, { lifeCyclePhase: 'Put into Service' }, { lifeCyclePhase: 'Waste Disposal' }, { lifeCyclePhase: 'Installation' }, { lifeCyclePhase: 'Use' }];
export const appLanguageOptions = [
  { code: 'en', label: 'English' },
  { code: 'zh', label: 'Chinese' },
  { code: 'pl', label: 'Polish' },
  { code: 'nl', label: 'Dutch' },
  { code: 'tr', label: 'Turkish' },
  { code: 'ko', label: 'Korean' },
  { code: 'vi', label: 'Vietnamese' },
  { code: 'th', label: 'Thai' },
  { code: 'da', label: 'Danish' },
  { code: 'sv', label: 'Swedish' },
  { code: 'pt', label: 'Portuguese' },
  { code: 'de', label: 'German' },
  { code: 'sp', label: 'Spanish' },
  { code: 'fr', label: 'French' },
  { code: 'it', label: 'Italian' },
];
export const appLanguageLabels = appLanguageOptions.reduce((labels, language) => {
  labels[language.code] = language.label;
  return labels;
}, {} as Record<string, string>);
export const templateLanguageCodeMap = {
  en: 'Eng',
  pt: 'Por',
  de: 'Ger',
  sp: 'Spa',
  fr: 'Fre',
  it: 'Ita',
} as const;

export const getTemplateLanguageValue = (languageCode: string = 'en') => {
  return templateLanguageCodeMap[languageCode] || languageCode;
};

export const availableLngs = 
  appLanguageOptions.map(language => ({
    title: language.label,
    code: language.code,
    val: getTemplateLanguageValue(language.code),
  }));
export const langUserProfile = 
[
  { "title": "Afrikaans", "val": "af" },
  { "title": "Albanian", "val": "sq" },
  { "title": "Amharic", "val": "am" },
  { "title": "Arabic", "val": "ar" },
  { "title": "Aramaic", "val": "arc" },
  { "title": "Armenian", "val": "hy" },
  { "title": "Assamese", "val": "as" },
  { "title": "Aymara", "val": "ay" },
  { "title": "Azerbaijani", "val": "az" },
  { "title": "Balochi", "val": "bal" },
  { "title": "Bambara", "val": "bm" },
  { "title": "Bengali", "val": "bn" },
  { "title": "Berber", "val": "ber" },
  { "title": "Bhojpuri", "val": "bho" },
  { "title": "Bislama", "val": "bi" },
  { "title": "Bosnian", "val": "bs" },
  { "title": "Bulgarian", "val": "bg" },
  { "title": "Burmese", "val": "my" },
  { "title": "Catalan", "val": "ca" },
  { "title": "Cebuano", "val": "ceb" },
  { "title": "Chinese", "val": "zh" },
  { "title": "Croatian", "val": "hr" },
  { "title": "Czech", "val": "cs" },
  { "title": "Danish", "val": "da" },
  { "title": "Dari", "val": "prs" },
  { "title": "Dhivehi", "val": "dv" },
  { "title": "Dutch", "val": "nl" },
  { "title": "Dzongkha", "val": "dz" },
  { "title": "English", "val": "en" },
  { "title": "Estonian", "val": "et" },
  { "title": "Ewe", "val": "ee" },
  { "title": "Fijian", "val": "fj" },
  { "title": "Filipino", "val": "fil" },
  { "title": "Finnish", "val": "fi" },
  { "title": "Flemish", "val": "nl-BE" },
  { "title": "French", "val": "fr" },
  { "title": "Frisian", "val": "fy" },
  { "title": "Ga", "val": "gaa" },
  { "title": "Galician", "val": "gl" },
  { "title": "Georgian", "val": "ka" },
  { "title": "German", "val": "de" },
  { "title": "Greek", "val": "el" },
  { "title": "Gujarati", "val": "gu" },
  { "title": "Haitian Creole", "val": "ht" },
  { "title": "Hausa", "val": "ha" },
  { "title": "Hebrew", "val": "he" },
  { "title": "Hindi", "val": "hi" },
  { "title": "Hmong", "val": "hmn" },
  { "title": "Hungarian", "val": "hu" },
  { "title": "Icelandic", "val": "is" },
  { "title": "Igbo", "val": "ig" },
  { "title": "Indonesian", "val": "id" },
  { "title": "Irish", "val": "ga" },
  { "title": "Italian", "val": "it" },
  { "title": "Japanese", "val": "ja" },
  { "title": "Javanese", "val": "jv" },
  { "title": "Kannada", "val": "kn" },
  { "title": "Kashmiri", "val": "ks" },
  { "title": "Kazakh", "val": "kk" },
  { "title": "Khmer", "val": "km" },
  { "title": "Kinyarwanda", "val": "rw" },
  { "title": "Korean", "val": "ko" },
  { "title": "Kurdish", "val": "ku" },
  { "title": "Kyrgyz", "val": "ky" },
  { "title": "Lao", "val": "lo" },
  { "title": "Latin", "val": "la" },
  { "title": "Latvian", "val": "lv" },
  { "title": "Lithuanian", "val": "lt" },
  { "title": "Luxembourgish", "val": "lb" },
  { "title": "Macedonian", "val": "mk" },
  { "title": "Malagasy", "val": "mg" },
  { "title": "Malay", "val": "ms" },
  { "title": "Malayalam", "val": "ml" },
  { "title": "Maltese", "val": "mt" },
  { "title": "Maori", "val": "mi" },
  { "title": "Marathi", "val": "mr" },
  { "title": "Mongolian", "val": "mn" },
  { "title": "Nepali", "val": "ne" },
  { "title": "Norwegian", "val": "no" },
  { "title": "Odia (Oriya)", "val": "or" },
  { "title": "Pashto", "val": "ps" },
  { "title": "Persian", "val": "fa" },
  { "title": "Polish", "val": "pl" },
  { "title": "Portuguese", "val": "pt" },
  { "title": "Punjabi", "val": "pa" },
  { "title": "Quechua", "val": "qu" },
  { "title": "Romanian", "val": "ro" },
  { "title": "Russian", "val": "ru" },
  { "title": "Samoan", "val": "sm" },
  { "title": "Sanskrit", "val": "sa" },
  { "title": "Serbian", "val": "sr" },
  { "title": "Sesotho", "val": "st" },
  { "title": "Shona", "val": "sn" },
  { "title": "Sindhi", "val": "sd" },
  { "title": "Sinhala", "val": "si" },
  { "title": "Slovak", "val": "sk" },
  { "title": "Slovenian", "val": "sl" },
  { "title": "Somali", "val": "so" },
  { "title": "Spanish", "val": "es" },
  { "title": "Sundanese", "val": "su" },
  { "title": "Swahili", "val": "sw" },
  { "title": "Swedish", "val": "sv" },
  { "title": "Tajik", "val": "tg" },
  { "title": "Tamil", "val": "ta" },
  { "title": "Tatar", "val": "tt" },
  { "title": "Telugu", "val": "te" },
  { "title": "Thai", "val": "th" },
  { "title": "Tigrinya", "val": "ti" },
  { "title": "Tok Pisin", "val": "tpi" },
  { "title": "Tswana", "val": "tn" },
  { "title": "Turkish", "val": "tr" },
  { "title": "Turkmen", "val": "tk" },
  { "title": "Ukrainian", "val": "uk" },
  { "title": "Urdu", "val": "ur" },
  { "title": "Uzbek", "val": "uz" },
  { "title": "Vietnamese", "val": "vi" },
  { "title": "Welsh", "val": "cy" },
  { "title": "Xhosa", "val": "xh" },
  { "title": "Yiddish", "val": "yi" },
  { "title": "Yoruba", "val": "yo" },
  { "title": "Zulu", "val": "zu" }
];
export const availableTemplates = [
  { title: 'Standard US Template', val: 'us' },
  { title: 'Standard German Template', val: 'gm' }
];
export const USA_ADDRESS = {
  date: moment().format('DD-MM-YYYY'),
  line1: 'Schmersal USA',
  line2: '15 Skyline Drive',
  line3: 'Hawthorne, NY 10532',
  line4: 'P: 914-347-4775',
  line5: 'F: 914-347-1567',
  line6: 'https://www.schmersalusa.com'
};

export const Germany_ADDRESS = {
  date: moment().format('DD-MM-YYYY'),
  line1: 'Schmersal Germany',
  line2: '15 Skyline Drive',
  line3: 'Hawthorne, NY 10532',
  line4: 'P: 914-347-4775',
  line5: 'F: 914-347-1567',
  line6: 'https://www.schmersalusa.com'
};

export class AppConstants {
  public static USER = 'user';
  public static ROLE = 'role';
  public static GROUP = 'group';
  public static RBAC = 'rbac';
  public static DELETE = 'Delete';
  public static EXIT = 'Exit';
  public static SUCCESS_SNACKBAR = 'success';
  public static WARNING_SNACKBAR = 'warning';
  public static ERROR_SNACKBAR = 'danger';
  public static ARE_YOU_SURE_TO_DELETE = 'Are_you_sure_you_want_to_delete';
  public static ARE_YOU_SURE_TO_CANCEL = 'Are_you_sure_you_want_to_cancel';
  public static ARE_YOU_SURE_TO_EDIT_PROJECT = 'Are_you_sure_you_want_to_edit_the_project';
  public static ARE_YOU_SURE_TO_DELETE_PROJECT = 'Are you sure you want to delete the Project ?';
  public static ARE_YOU_SURE_TO_BLOCK_PROJECT = 'Are you sure you want to block this project ?';
  public static ARE_YOU_SURE_TO_RELEASE_PROJECT = 'Are you sure you want to release this project ?';
  public static ARE_YOU_SURE_TO_CLOSE_PROJECT = 'Are you sure you want to close this project ?';
  public static ARE_YOU_SURE_TO_DELETE_OFFER = 'Are you sure you want to delete this offer ?';
  public static ARE_YOU_SURE_TO_EDIT_OFFER = 'Are_you_sure_you_want_to_edit_this_offer';
  public static ARE_YOU_SURE_TO_VIEW_OFFER = 'Are_you_sure_you_want_to_view_this_offer';
  public static ARE_YOU_SURE_TO_ASSIGN_OFFER = 'Are_you_sure_you_want_to_assign_this_offer';
  public static ARE_YOU_SURE_TO_DELETE_SERVICE = 'Are you sure you want to delete this service';
  public static ARE_YOU_SURE_TO_LOGOUT = 'Are you sure you want to logout ?';
  public static ARE_YOU_SURE_TO_EXIT = 'Are you sure you want to exit ?';
  public static YES = 'Yes';
  public static ARE_YOU_SURE_TO_MARK_SECTION_NA = 'Are you sure you want to mark current section as not applicable ?';
  public static ARE_YOU_SURE_TO_MARK_SUBSECTION_NA = 'Are you sure you want to mark current sub-section as not applicable ?';
  public static ARE_YOU_SURE_TO_MARK_STEP_NA = 'Are you sure you want to mark current step as not applicable ?';
  public static ADD_HAZARD = 'Add hazard';
  public static COPY_HAZARD = 'Copy hazard';
  public static RENAME_SECTION = 'Rename section';
  public static INITIAL_HAZARD_EXISTS = "Initial Hazard Exists";
  public static CONTROL_MEASURE_EXISTS = "Control Measure Exists";
  public static MIDDLE: "middle" = "middle";
  public static TOP: "top" = "top";
  public static BOTTOM: "bottom" = "bottom";
  public static ONLY_IMAGE_FILES_ALLOWED = 'image_file_types_allowed_msg';
  public static CANCEL = 'Cancel';
}

export const CharDateRanges = [
  { title: 'Day', id: 1 },
  { title: 'Last Week', id: 2 },
  { title: 'Month', id: 3 },
];
export const offerLegends = ['product', 'Total Offers', 'Offers Approved', 'Offer Pending Assignment', 'Offer Converted Order', 'Offer Pending Approval'];

export const projectLegends = ['product', 'Total Projects', 'Services In Progress', 'Services Completed', 'Total Services'];

export const orderLegends = ['product', 'Total Orders', 'Orders In Progress', 'Order Completed'];


export const barSeries = [{
  type: 'bar',
  barGap: 1,
  color: '#4472c4',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 1,
  color: '#a5a5a5',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  color: '#5b9bd5',
  barGap: 1,
  emphasis: {
    focus: 'series'
  }
}, {
  type: 'bar',
  barGap: 1,
  color: '#1e4b8d',
  emphasis: {
    focus: 'series'
  },
},
];

export const stackedBarSeries = [{
  type: 'bar',
  barGap: 0,
  stack: 'total',
  barWidth: '50%',
  color: '#4472c4',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 0,
  color: '#a5a5a5',
  stack: 'total',
  barWidth: '50%',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 0,
  color: '#5b9bd5',
  stack: 'total',
  barWidth: '50%',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 0,
  color: '#1e4b8d',
  stack: 'total',
  barWidth: '50%',
  emphasis: {
    focus: 'series'
  },
}
];


export const offerBarSeries = [{
  type: 'bar',
  barGap: 1,
  color: '#4472c4',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 1,
  color: '#a5a5a5',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  color: '#5b9bd5',
  barGap: 1,
  emphasis: {
    focus: 'series'
  }
}, {
  type: 'bar',
  barGap: 1,
  color: '#1e4b8d',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 1,
  color: '#1a46d0',
  emphasis: {
    focus: 'series'
  },
},
];

export const offerStackedBarSeries = [{
  type: 'bar',
  barGap: 0,
  stack: 'total',
  barWidth: '50%',
  color: '#4472c4',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 0,
  color: '#a5a5a5',
  stack: 'total',
  barWidth: '50%',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 0,
  color: '#5b9bd5',
  stack: 'total',
  barWidth: '50%',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 0,
  color: '#1e4b8d',
  stack: 'total',
  barWidth: '50%',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 0,
  stack: 'total',
  barWidth: '50%',
  color: '#1a46d0',
  emphasis: {
    focus: 'series'
  },
},
];

export const orderBarSeries = [{
  type: 'bar',
  barGap: 1,
  color: '#4472c4',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 1,
  color: '#a5a5a5',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  color: '#5b9bd5',
  barGap: 1,
  emphasis: {
    focus: 'series'
  }
}
];

export const orderStackedBarSeries = [{
  type: 'bar',
  barGap: 0,
  stack: 'total',
  barWidth: '50%',
  color: '#4472c4',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 0,
  color: '#a5a5a5',
  stack: 'total',
  barWidth: '50%',
  emphasis: {
    focus: 'series'
  },
}, {
  type: 'bar',
  barGap: 0,
  color: '#5b9bd5',
  stack: 'total',
  barWidth: '50%',
  emphasis: {
    focus: 'series'
  },
}
];
export class ObservationEvents {
  public static OFFER_DETAIL_FORM_VALIDITY = 'OfferDetailFormValidity';
  public static STEPPER_TYPE = 'steperType';
  public static MACHINE_FILTER = 'machineFilter';
  public static CLOSE_FILTER_POPUP = 'closeFilterPopup';
  public static APPLIED_FILTER = 'appliedFilter';
  public static IS_OPENED_BY_BTN = 'isOpendByFilterBtn';
  public static EDIT_FILTER = 'editFilter';
  public static CLOSE_RBAC = 'closeRbac';
  public static GATEWAY_TIMEOUT = 'gatewayTimeout';
  public static FILE_UPLOAD = 'fileUpload';
  public static ERROR_OCCURRED = 'errorOccurred';
  public static FILE_UPLOAD_SUCCESS = 'fileUploadSuccess';
  public static FILE_VALIDATION_ERROR = 'fileValidationError';
  public static DOWNLOAD_FILE = 'downloadFile';
  public static HIDE_EXIT_BUTTON: 'hideExitButton';
  public static MACHINE_CALL = 'machineCall';
  public static NEW_ROADMAP = 'newRoadmap';
  public static IMPORT_ROADMAP = 'importRoadmap';
  public static READONLY_ROADMAP = 'readonlyRoadmap';
  public static GO_BACK = 'goBack';
  public static EXIT_ROADMAP = 'exitRoadmap';
}

export class libraryConstants {
  public static MACHINE_LIBRARY = 'Machine Library';
  public static STANDARD_DOCUMENTS = 'Standard Documents';
  public static LEGISLATION_DOCUMENTS = 'Legislation Documents';
  public static ROADMAPS = 'Roadmaps';
  public static USER_ROADMAPS = 'User Roadmaps';
  public static RISK_ASSESSMENT_REPORT = 'Risk Assessment Static Report Templates';
  public static QUOTE_TEMPLATES = 'Quote Templates';
  public static CONTROL_MEASURES = 'Control Measures';
  public static INITIAL_HAZARDS = 'Initial Hazards';
  public static INDUSTRY_SECTOR = 'Industry Sector';
  public static PICTOGRAM_IMAGES = 'Pictogram Images';

}

export class urlPathConstants {
  public static defaultMachineUrl = 'assets/images/Machine Library.svg';
  public static viewProjectPath = 'project-management/project-detail/';
  public static viewOfferPath = 'offer-management/view-offer/';
  public static viewOrderPath = 'order-management/view-order/';
  public static viewServicePath = 'order-management/project-detail/';
  public static imageUploadUrl = environment.riskassessmentBaseUrl + 'upload_image';
  public static userVideoGuide = environment.production ? 'https://schmersal.sharepoint.com/sites/BluePrint' : 'https://dnaofsafetydev.sharepoint.com/:u:/r/sites/BluePrint/SitePages/Blue.print-Video-Guide.aspx?csf=1&web=1&share=EXCzPFngqPZDqBC_Sl1uH3wBLdDuggy_hK_Tsx7t8PKttw&e=otcG9i';
}

export class StorageKeys {
  public static NEW_HAZARD_DETAILS = 'newhazardDetails';
  public static ASSIGNED_STAFF = 'assignedStaff';
  public static VIEW_ROADMAP = 'viewedRoadMap';
  public static READONLY_ROADMAP_DATA ='readonlyRoadmapData';
  public static SELECTED_ROADMAP_TYPE = 'selectedRoadmapType'
 public static SERVICE_MACHINE_ID = 'serviceMachineId'
}

export class CustomerManagementConstants {
  public static SALES_ORGNIZATION = 'Sales Organisation';
  public static CONTACTS = 'Contacts';
  public static CUSTOMER = 'Customer';
  public static SERVICE_MATERIAL = 'Service Material';
}

export class ServiceManagementConstants {
  public static SERVICE_DETAILS = 'Service Details';
  public static MACHINE_DETAILS = 'Machine Details';
}

export class MachineManagementConstants
{
  public static ALL_MACHINES = 'All Machines';
  public static ATTRIBUTES_MANAGEMENT = 'Attributes Management';
}

export class MachineAttributesManagementConstants
{
  public static APPLICATION = 'Application';
  public static MACHINE_TYPE = 'Machine Type';
  public static SPECIFIC_FEATURES = 'Specific Features';
  public static CONTROL_SYSTEM = 'Control System';
}

export class ProjectDetailsConstants
{
  public static PROJECT_OVERVIEW = 'Project Overview';
  public static PROJECT_SERVICE_DETAILS = 'Service Details';
  public static SERVICE_ROADMAP_DETAILS = 'Service Roadmap Details';
  public static MACHINE_DETAILS = 'Machine Details';
  public static LOG_ACTUAL_HOURS = 'Log Actual Hours';
  public static PROJECT_ITEMS_VIEW = 'Project Items View';
}

export class UserManagementConstants
{
  public static USER_MANAGEMENT = 'User Management';
  public static ROLE_MANAGEMENT = 'Role Management';
  public static GROUP_MANAGEMENT = 'Group Management';
  public static RBAC_PERMISSIONS = 'RBAC Permissions';
}

export class MachineInfoConstants
{
  public static MACHINE_DETAILS = 'Machine Details';
  public static ATTRIBUTES_DETAILS = 'Attributes Details';
  public static MACHINE_LIMITS = 'Machine Limits';
  public static MACHINE_REFERENCES = 'References';
  public static MACHINE_IMAGES = 'Machine Images';
  public static ROADMAPS = 'Roadmaps';
  public static SISTEMA = 'Sistema';
}

export class MachineDetailConstants {
  public static MACHINE_DETAILS = 'Machine Details';
  public static ATTRIBUTES_DETAILS = 'Attributes Details';
  public static MACHINE_LIMITS = 'Machine Limits';
  public static ROADMAPS = 'Roadmaps';
  public static SISTEMA = 'Sistema';
}

export class HazardMeasureConstants {
  public static INITIAL_HAZARDS = 'Initial Hazards'
  public static MEASURES = 'Measures';
  public static TITLE = 'Initial Hazards & Measures';
}

export class PathNames {
  public static SALES_ORGNIZATION = 'sales-organization';
  public static CUSTOMER = 'customer';
  public static CONTACTS = 'contacts';
}

export class PickType {
  public static PICK_MEASURE = 'Pick Measure';
  public static PICK_INITIAL_HAZARD = 'Pick Initial Hazard';
}

export function getApiCallDescription(apiCallType: string, title: string): string {
  switch (apiCallType) {
    case 'edit':
      return 'customer_management_updated_successfully';
    case 'delete':
      return 'customer_management_deleted_successfully';
    default:
      return 'customer_management_created_successfully';
  }
}

export function getApiCallErrorDescription(apiCallType: string, title: string): string {
  switch (apiCallType) {
    case 'delete':
      return 'customer_management_delete_failed';
    default:
      return 'something_went_wrong';
  }
}

export function getCustomerManagementEntityTranslationKey(title: string): string {
  switch (title) {
    case CustomerManagementConstants.SALES_ORGNIZATION:
      return 'sales_organisation_entity';
    case CustomerManagementConstants.SERVICE_MATERIAL:
      return 'service_material_entity';
    case CustomerManagementConstants.CUSTOMER:
      return 'customer_entity';
    case CustomerManagementConstants.CONTACTS:
      return 'contact_entity';
    default:
      return title;
  }
}

export const Language = {
  Eng: 'English',
  Por: 'Portuguese',
  Spa: 'Spanish',
  Ger: 'German',
  Fre: 'French',
  Ita: 'Italian'
};

export const getFullLanguageName = (language: string = ''): string => {
  const trimmedLanguage = language?.trim();
  if (!trimmedLanguage) {
    return '';
  }

  const normalizedLanguage = trimmedLanguage.toLowerCase();
  const normalizedTemplateLanguage =
    trimmedLanguage.charAt(0).toUpperCase() + trimmedLanguage.slice(1).toLowerCase();

  return (
    appLanguageLabels[normalizedLanguage] ||
    appLanguageLabels[normalizedLanguage === 'es' ? 'sp' : normalizedLanguage] ||
    Language[trimmedLanguage] ||
    Language[normalizedTemplateLanguage] ||
    langUserProfile.find(item => item.val?.toLowerCase() === normalizedLanguage)?.title ||
    trimmedLanguage
  );
};
export const selectRoadmapFilter = [
  { label: 'Select All', key: 'is_select_all', value: true },
  { label: 'Yes, Compliant', key: 'is_compliant', value: true },
  { label: 'Not Compliant', key: 'is_not_compliant', value: true },
  { label: 'Not applicable', key: 'is_not_applicable', value: true },
  { label: 'Report Hazard', key: 'is_hazard', value: true },
];

export class IconUrls {
  public static SUCCESS_ICON = '../../assets/icon/success_icon.svg';
  public static SUCCESS_CLOSE = '../../assets/icon/success_close.svg';

  public static WARNING_ICON = '../../assets/icon/warning_icon.svg';
  public static WARNING_CLOSE = '../../assets/icon/warning_close.svg';

  public static ERROR_ICON = '../../assets/icon/error_icon.svg';
  public static ERROR_CLOSE = '../../assets/icon/error_close.svg';
}

export class Froala_Constants {
  public static LICENSE_KEY = 'uXD2lA6E6G5A4H4C3C10dNSWXf1h1MDb1CF1PLPFf1C1EESFKVlA3C11A8A4D2B4G3G2E3H3==';
}

export enum DropdownType {
  Customer = '1',
  Project = '2',
  SalesOrg = '3',
  Country = '4',
  MachineType = '5',
  Manufacturer = '6',
  Model = '7',
  MachineName = '8',
  Application = '9',
  ControlSystem = '10',
  SpecificFeature = '11'
}

export const LIMIT_TYPES = {
    USE_LIMITS: 1,
    SPACE_LIMITS: 2,
    TIME_LIMITS: 3,
    OTHER_LIMITS: 4
  }

export const ENTRY_TYPES = {
    MACHINE_MODES: 'MachineModes',
    USE_OF_MACHINERY: 'UseOfMachinery',
    EXPOSURE_OF_OTHER_PERSON: 'ExposureOfOtherPerson',
    NUMBER_OF_OPERATORS: 'NumberOfOperators',
    OTHER_USER_LIMIT: 'OtherUserLimit',
    USER_ROLES: 'UserRoles',
    MACHINE_SIZE: 'MachineSize',
    HUMAN_INTERACTION: 'HumanInteraction',
    POWER_SUPPLY_INTERFACE: 'PowerSupplyInterface',
    OTHER_SPACE_LIMIT: 'OtherSpaceLimit',
    LIFE_OF_MACHINERY: 'LifeOfMachinery',
    OTHER_TIME_LIMIT: 'OtherTimeLimit',
    RECOMMENDED_SERVICE_INTERVALS: 'RecommendedServiceIntervals',
    PROPERTIES_OF_MATERIAL_TO_BE_PROCESSED: 'PropertiesOfMaterialToBeProcessed',
    LEVEL_OF_CLEANLINESS: 'LevelOfCleanliness',
    ENVIRONMENTAL_CONDITIONS: 'EnvironmentalConditions',
    OTHER: 'Other',
    PHASES_OF_MACHINE_LIFE_CYCLE: 'PhasesOfMachineLifeCycle',
    OTHER_LIMIT_FIELD_NAME_AND_DESCRIPTION: 'OtherLimitFieldNameAndDescription'
  }